module.exports = __webpack_public_path__ + "static/img/b1.85b0daa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/b1.png
// module id = 1Zo5
// module chunks = 1